import { render } from "./DayHoverInfoComponent.vue?vue&type=template&id=b6da87da"
import script from "./DayHoverInfoComponent.vue?vue&type=script&lang=js"
export * from "./DayHoverInfoComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__